module.exports = __webpack_public_path__ + "img/icon-operation.71fcf2be.png";